export default {
  logoAlt: "{{siteTitle}} Logo",
  nav: {
    home: "Home",
    about: "About",
    contact: "Contact",
  },
  about: {
    javad: "Javad",
    faranack: "Faranack",
  },
  theme: {
    toLight: "Switch to light mode",
    toDark: "Switch to dark mode",
  },
  language: {
    toFa: "تغییر به فارسی",
    toEn: "Switch to English",
  },
};
